<template>
    <div class="footerArea " v-show="showDiandiFooter">
        <div class="footerPart box">
            <div class="infoBox item">
                <h1>点滴关怀</h1>
                <p class="juyouInfo">我们是国内领先的员工关怀与企业福利平台，为企业提供员工关怀与生活服务的技术系统与相关服务。我们帮助企业打造有温度的工作环境，提升员工的企业归属感。企业可以通过我们的平台，为员工提供全面的职业关怀与福利服务，覆盖员工入职、在职、离职、生日、周年、节庆等多达48种员工关怀场景。
                </p>
            </div>
            <div class="juyouConnectArea">
                <h2 class="font16">友情链接</h2>
                <p><a href="https://www.ddguanhuai.com/Show/help.html?#zchyh">帮助中心</a>
                <a href="https://www.ddguanhuai.com/Show/help.html?#gsjj">了解我们</a>
                <a href="https://www.ddguanhuai.com/Show/help.html?#hyzcxy">网站协议</a>
                </p>
                <p><i class="font16">客服热线</i>（9：00 - 18：00）</p>
                <div class="phoneNumBox"><i class="contentPhone"></i>400-051-1302</div>
            </div>
            <img class="juyouScanCode" src="../../assets/images/daindi_gongzong.png" alt="点滴">
        </div>
        <p class="div-hr" >@2020 neigou.com | 星光物语（北京）电子商务有限公司 | 北京市东城区和平里北街6号院15号楼701 | 联系电话 400-051-1302 <br/><a target="_blank" href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action">京ICP备14018944号</a> | 统一社会信用代码 91110105078517042D |
            <img src="//cdn.neigou.com/app/birthday/statics/images/gongan.png" alt="">&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102003482">京公网安备11010102003482号</a> | 食品流通许可证 --| <a href="//cdn.neigou.com/app/b2c/neigou_statics/file/businesslicense.pdf" target="_blank">营业执照</a>  | <a target="_blank" href="//cdn.neigou.com/app/b2c/neigou_statics/file/cbwlicense.pdf" >出版物经营许可证</a></p>
    </div>
</template>

<script>
    import cookie from 'js-cookie';
    export default {
        props:[
            'showDiandiFooter'
        ],
        data() {
            return {
                config: global.config,
                userChannel: cookie.get('channel')
            }
        },
        created(){
            
        },
        methods:{
            returnHome(){
                if(this.userChannel == 1){
                    window.location.href ='http://www.life.neigou.com'
                }else{
                    this.$router.push('/')
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.div-hr a {
    color: #5f5f5f;
}
.div-hr {
    background: #333;;
    position: absolute;
    left: 0;
    width: 100%;
    border-top: 1px solid #3c3c3c;
    text-align: center;
    color: #5f5f5f;
    cursor: default;
    font-size: 13px;
    line-height: 32px;
    padding: 15px 0px;
    letter-spacing: 1px;
    min-width: 1170px;
}
.font16{
    font-size: 16px;
    color: #ffffff;
}
.footerPart{
    width: 1200px;
    margin: 0 auto;
}
.footerArea{
    background: #333;
    border-top: 4px solid #59d2f9;
    color: #898989;
    font-size: 14px;
    .phoneNumBox{
        font-style:italic;
        font-size: 24px;
        color: #59d2f9;
        position: relative;
        padding-left: 30px;
    }
    .juyouConnectArea{
        font-size: 14px;
        h2{
            
            margin: 40px 0 22px 0;
        }
        p{
            margin-bottom: 16px;
        }
        a{
            font-size: 14px;
            color: #898989;
            margin-right: 10px;
        }
    }
    .contentPhone{
        position: absolute;
        left: 0;
        height: 32px;
        width: 24px;
        display: inline-block;
        background: url('../../assets/images/diandiphone.png') no-repeat center;
        background-size: 100%;
    }
    .infoBox{
        margin-top: 40px;
        margin-bottom: 24px;
        h1{
            font-size: 18px;
            color: #ffffff;
            font-weight: bolder;
            margin-bottom: 20px;
        }
    }
    .juyouScanCode{
        height: 90px;
        width: 90px;
        margin-top: 40px;
    }
    .juyouInfo{
        line-height: 26px;
    }
    .juyouConnectArea{
        margin: 0 50px;
        width: 250px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/shares/diandiFooter.vue